import FetchError from './FetchError';

export default FetchError;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/FetchError/index.js